import { MyEmergencyPlanStage } from '@/features';

export type MyEmergencyPlanStageKeys = keyof typeof stageIds;

enum stageIds {
  G2,
  REF5,
  REF8,
  REF9,
  'REF10-13',
  REF14,
  G3,
  REF15,
  REF17,
  REF19,
  G4,
  REF20,
  G5,
  REF21,
  REF23,
  REF24,
  REF25,
  REF26,
  G6,
  REF27,
  REF28,
  REF29,
  'REF29.1',
  'REF29.4',
  G7,
  REF30,
  REFPRE31,
  REF31,
  REF32,
  REF33,
  REF34,
  REF36,
  REF37,
  REF38,
  G9,
  REF39,
  REF40,
}

export const MyEmergencyPlanStages: Record<MyEmergencyPlanStageKeys, MyEmergencyPlanStage> = {
  //* Stage 1 (Name and location)
  G2: { stepId: 1, componentName: 'G2', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF5: { stepId: 1, componentName: 'REF05', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },

  //* Stage 2 (What are your triggers to act)
  REF8: { stepId: 2, componentName: 'REF08', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  REF9: { stepId: 2, componentName: 'REF09', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  'REF10-13': { stepId: 2, componentName: 'REF10-13', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF14: { stepId: 2, componentName: 'REF14', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },

  //* Stage 3 (Who do you need to protect)
  G3: { stepId: 3, componentName: 'G3', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  REF15: { stepId: 3, componentName: 'REF15', primaryButtonText: 'Next', secondaryButtonText: 'Cancel', verticalMargin: '' },
  REF17: {
    stepId: 3,
    componentName: 'REF17',
    primaryButtonText: 'Got it',
    secondaryButtonText: 'Cancel',
    verticalMargin: '',
  },
  REF19: { stepId: 3, componentName: 'REF19', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },

  //* Stage 4 (Your leave early plan)
  G4: { stepId: 4, componentName: 'G4', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  REF20: { stepId: 4, componentName: 'REF20', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  G5: { stepId: 4, componentName: 'G5', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF21: { stepId: 4, componentName: 'REF21', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF23: { stepId: 4, componentName: 'REF23', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  REF24: { stepId: 4, componentName: 'REF24', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF25: { stepId: 4, componentName: 'REF25', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  REF26: { stepId: 4, componentName: 'REF26', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },

  //* Stage 5 (Bushfire Events)
  G6: { stepId: 5, componentName: 'G6', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  REF27: { stepId: 5, componentName: 'REF27', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF28: { stepId: 5, componentName: 'REF28', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF29: { stepId: 5, componentName: 'REF29', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  'REF29.1': { stepId: 5, componentName: 'REF29.1', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  'REF29.4': { stepId: 5, componentName: 'REF29.4', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  G7: { stepId: 5, componentName: 'G7', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF30: { stepId: 5, componentName: 'REF30', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },

  //* Stage 6 (Severe Weather Events)
  REFPRE31: { stepId: 6, componentName: 'REFPRE31', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  REF31: { stepId: 6, componentName: 'REF31', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF32: { stepId: 6, componentName: 'REF32', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  REF33: { stepId: 6, componentName: 'REF33', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF34: { stepId: 6, componentName: 'REF34', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF36: { stepId: 6, componentName: 'REF36', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  REF37: { stepId: 6, componentName: 'REF37', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF38: { stepId: 6, componentName: 'REF38', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },

  //* Stage 7 (Who will you tell)
  G9: { stepId: 7, componentName: 'G9', primaryButtonText: 'Got it', secondaryButtonText: 'Cancel' },
  REF39: { stepId: 7, componentName: 'REF39', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
  REF40: { stepId: 7, componentName: 'REF40', primaryButtonText: 'Next', secondaryButtonText: 'Cancel' },
} as const;
